import type {CodeRecord} from './types';

export interface CatalogPreview {schemaVersion:1;catalogFingerprint:string;records:CodeRecord[]}
// This cache contains copies of published records, never edited descriptions.
// A catalog fingerprint, rather than its version label alone, prevents reuse
// after an import changes dates, rows, mappings or source contents.
export function restorePreview(preview:CatalogPreview|undefined,fingerprint:string):CodeRecord[] {
  if(!preview||preview.schemaVersion!==1||preview.catalogFingerprint!==fingerprint||!Array.isArray(preview.records))return [];
  const seen=new Set<string>();
  for(const r of preview.records){
    if(!r||!['diagnosis','procedure'].includes(r.kind)||r.classification!==(r.kind==='diagnosis'?'ICD-10-IM':'CIPI')||r.id!==`${r.kind}:${r.code}`||seen.has(r.id)||
      !['id','code','description','classification','version','inclusions','originalMapping'].every(key=>typeof r[key as keyof CodeRecord]==='string')||
      !r.code||!r.description||typeof r.terminal!=='boolean'||!Array.isArray(r.mappings)||
      r.mappings.some(m=>!m||typeof m.expression!=='string'||typeof m.description!=='string'||!Array.isArray(m.codes)||m.codes.some(c=>typeof c!=='string')))return [];
    seen.add(r.id);
  }
  return preview.records;
}
export function makePreview(fingerprint:string,records:CodeRecord[],ids:string[]):CatalogPreview {
  const wanted=new Set(ids);
  return {schemaVersion:1,catalogFingerprint:fingerprint,records:records.filter(r=>wanted.has(r.id))};
}
